export const BUSINESS = {
  name: "Rob Baker's Garage",
  phone: "+16506975063",
  phoneFormatted: "(650) 697-5063",
  address: {
    street: "1009 El Camino Real",
    city: "Millbrae",
    state: "CA",
    zip: "94030",
    full: "1009 El Camino Real, Millbrae, CA 94030",
  },
  hours: {
    weekdays: "9:00 AM – 5:30 PM",
    weekends: "Closed",
    allDays: "Mon–Fri: 9:00 AM – 5:30 PM",
  },
  email: null,
  website: "https://autorepairshopmillbraeca.com",
  googleMapsUrl: "https://maps.app.goo.gl/BQhtc3abpad7eLYcA",
  yelpUrl: "https://www.yelp.com/biz/rob-bakers-garage-millbrae",
  facebookUrl: "https://www.facebook.com/ROBbakersGarage/",
  instagramUrl: "https://www.instagram.com/robbakersgarage/",
  rating: "4.8",
  reviewCount: "100+",
  yearEstablished: 1972,
  tagline: "Millbrae's Trusted Auto Repair Since 1972",
  staff: [
    { name: "Alex T.", role: "Master Technician & Owner" },
    { name: "Rob Baker", role: "Founder" },
  ],
}
